import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const DoubleChinReduction = lazyWithPreload(
  () => import('./DoubleChinReduction'),
)
